import { useFormikContext } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';

const InstructionSelect = () => {
  const { values, setValues } = useFormikContext();
  const product = values?.description?.product;
  const instructionOptions = useMemo(
    () =>
      product?.instructions.map((item, index) => ({
        key: item.id,
        text: item.name ?? `Instruction ${index + 1}`,
        value: item.id,
        data: item,
      })) || [],
    [product],
  );

  const setValueByInstruction = instruction => {
    setValues({
      ...values,
      instructionId: instruction?.id,
      doseUnitCode: instruction?.doseUnit ?? values.doseUnitCode,
      amountPerTime: instruction?.dose ?? values.amountPerTime,
      routeCode: instruction?.route ?? values.routeCode,
      frequencyCode: instruction?.frequency ?? values.frequencyCode,
      duration: instruction?.duration ?? values.duration,
      durationUnitCode: instruction?.durationUnit ?? values.durationUnitCode,
      note: instruction?.note ?? values.note,
    });
  };

  const resetInstruction = () => {
    setValues({
      ...values,
      instructionId: '',
      doseUnit: '',
      doseUnitCode: '',
      amountPerTime: '',
      route: '',
      frequency: '',
      frequencyCode: '',
      duration: undefined,
      durationUnit: '',
      durationUnitCode: '',
    });
  };

  useEffect(() => {
    if (values.mode === 'add' && instructionOptions.length > 0) {
      setValueByInstruction(instructionOptions[0].data);
    } else if (
      (values.mode === 'add' && instructionOptions.length === 0) ||
      values.useCustomInstruction
    ) {
      resetInstruction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instructionOptions]);
  return (
    <div>
      {instructionOptions?.length > 0 && !values.useCustomInstruction ? (
        <Dropdown
          options={instructionOptions}
          placeholder="Select instruction"
          value={values.instructionId}
          onChange={(_, data) => {
            const selectedInstruction = product?.instructions.find(item => item.id === data.value);
            setValueByInstruction(selectedInstruction);
          }}
        />
      ) : (
        'N/A'
      )}
    </div>
  );
};

export default InstructionSelect;
